import { round } from 'lodash'

import { formatDate } from '../../../utils/functions'

export function getFileName(fundName, asofdate) {
  return (
    fundName &&
    `${fundName.replace(/\s/g, '_')}_holdings_${formatDate(
      asofdate,
      'yyyyMMdd'
    )}.csv`
  )
}

export function getTotalMarketValue(data) {
  return data && data.reduce((total, holding) => total + holding.marketValue, 0)
}

export function getTotalNetAssets(data) {
  return (
    data &&
    data.reduce((total, holding) => total + round(holding.weight * 100, 1), 0)
  )
}
